import React, { useState, useEffect } from 'react'
import Header from '../BaseComponents/Header'
import FotterMain from '../BaseComponents/FotterMain'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { baseURL, becomeDealer, googleCaptchaAPIKey } from '../../networkCalls';
import SEO from '../BaseComponents/SEO';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Link } from "react-router-dom";
import { Autocomplete } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { actionTypes, useStateValue } from '../../store';
import ReCAPTCHA from 'react-google-recaptcha';
import CryptoJS from "crypto-js";

// Danger detection helpers: SQL-like tokens and HTML tags (client-side UX checks only)
const containsSQLLikePattern = (str = "") => {
    if (!str || typeof str !== "string") return false;
    return /(--|;|\/\*|\*\/|\b(select|insert|update|delete|drop|alter|create|shutdown|truncate|exec|declare|union)\b)/i.test(str);
};
const containsHTMLTag = (str = "") => {
    if (!str || typeof str !== "string") return false;
    return /<[^>]+>/i.test(str);
};
const containsUnsafePattern = (str = "") => containsSQLLikePattern(str) || containsHTMLTag(str);

const validationSchema = yup.object({
    name: yup
        .string('Enter your Name')
        .required('Full Name is a required field')
        .max(100, 'Name too long')
        .test('no-unsafe', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email ID is a required field')
        .max(100, 'Email too long')
        .test('no-unsafe-email', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    mobile: yup
        .string('')
        .required('Mobile Number a required field')
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(10, 'Enter 10 digit mobile number')
        .max(10, 'Enter 10 digit mobile number'),
    address: yup
        .string('Enter your address')
        .required('Address is a required field')
        .max(300, 'Address too long')
        .test('no-unsafe-address', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    city: yup
        .string('Enter your city')
        .required('City is a required field')
        .test('no-unsafe-city', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    state: yup
        .string('Enter your state')
        .required('State is a required field')
        .test('no-unsafe-state', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    pincode: yup
        .string('')
        .required('Postal Code is a required field')
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(6, 'Enter 6 digit Postal Code')
        .max(6, 'Enter 6 digit Postal Code')
        .test('no-unsafe-pincode', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    country: yup
        .string('Enter your state')
        .required('Country is a required field')
        .test('no-unsafe-country', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    geographical: yup
        .string('Enter your state')
        .required('Geographical Coverage is a required field')
        .test('no-unsafe-geo', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    aboutbusiness: yup
        .string('Enter your state')
        .required('About your Business is a required field')
        .test('no-unsafe-about', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),
    firmName: yup
        .string('Enter your firm name')
        .required('Firm Name is a required field')
        .test('no-unsafe-firm', 'Invalid characters or HTML tags detected', (val) => !containsUnsafePattern(val)),


});
const BecomeADealer = () => {
    const TEST_SITE_KEY = googleCaptchaAPIKey;
      const recaptchaRef = React.createRef();
      const [captchavalue, setCaptchavalue] = React.useState("");
      const onVerifyCaptcha = (captchavalue) => {
        setCaptchavalue(captchavalue);
      };
    const [{ token, huid }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const [errMessage, setErrMessage] = useState('');
    const toTop = () => {
        window.scrollTo(0, 0);
    }
    useEffect(() => {
        // toTop();
    }, []);

    const formik = useFormik({
        initialValues: {
            name: '',
            mobile: '',
            email: '',
            address: '',
            city: '',
            state: '',
            pincode: '',
            country: '',
            geographical: '',
            aboutbusiness: '',
            firmName: ''
        },

        validationSchema: validationSchema,
        onSubmit: (values) => {
            // client-side check for unsafe content
            const fieldsToCheck = ['name', 'mobile', 'email', 'address', 'city', 'state', 'pincode', 'country', 'geographical', 'aboutbusiness', 'firmName'];
            for (const f of fieldsToCheck) {
                if (containsUnsafePattern(values[f])) {
                    if (formik && typeof formik.setFieldError === 'function') formik.setFieldError(f, 'Invalid characters or HTML tags detected');
                    setErrMessage('Invalid characters or HTML tags detected in input. Please remove SQL-like tokens or any HTML tags and try again.');
                    return;
                }
            }
            setErrMessage('');
            console.log('data to push', values)
            setLoading(true);
            const Secret = CryptoJS.SHA256(values.email + values.mobile).toString();
            becomeDealer({...values, "captcha":captchavalue}).then((res) => {
                setLoading(false);
                switch (res.data.status) {
                    case 1:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        return true;
                    case 0:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        break;
                    default:
                        return;
                }
            });

        },
    });

    const cddl = [
        {
            value: 'india',
            label: 'India',
        },
    ];
    const [agree, setAgree] = useState(false);
    const haveAgree = (event) => {
        setAgree(event.target.checked);
    };
  const enabledbtncapt = captchavalue != "" && agree;

    return (
        <>
            <SEO
                title="Become a Dealer"
                description=""
                name="HIPP - Honda India Power"
                url="https://www.hondaindiapower.com/become-a-dealer"
                type='Website' />
            <Header />
            <div className="post-view__header post-header post-header--has-image" style={{ display: 'block' }}>
                <div className="post-header__image post-header__image-car " style={{ textAlign: 'center' }}>
                    <LazyLoadImage
                        alt=""
                        effect="blur"
                        className='img-fluid'
                        src={`https://hondaold.wipl.co.in/front/media/home-why-honda-parallax.jpg`}
                    />
                </div>
            </div>
            <div className='innerpagebg pt-5 pb-5' style={{ zIndex: '1', position: 'relative' }}>
                <div className='container pt-1 pb-5' style={{ textAlign: 'justify' }}>
                    <div className='col-lg-8 col-mg-12 col-sm-12 col-12 text-start m-auto'>
                        <div className='card p-4 rounded-0 shadow-sm'>
                            <div className="align-items-center text-left">
                                <h3 className='d-inline-block m-0 fw-bold txtdgray'>
                                    Become An <span className='txtred'>Authorised Dealer</span> for <br />Honda India Power Products.
                                </h3>
                            </div>
                            <p className='mt-2 f16'>Kindly enter the required information if you wish to obtain<br />authorisation as a Honda Dealer.</p>
                            <hr className='mt-0' />
                            <form onSubmit={formik.handleSubmit} autoComplete="off">
                                {errMessage ? <div className="alert alert-danger">{errMessage}</div> : null}
                                <div className='row'>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="name"
                                            name="name"
                                            label="Contact Person Name *"
                                            type="text"
                                            value={formik.values.name}
                                            onChange={(e) => {
                                                formik.setFieldValue("name", e.target.value.replace(/[^a-z0-9\s]/gi, ''));
                                            }}
                                            error={formik.touched.name && Boolean(formik.errors.name)}
                                            helperText={formik.touched.name && formik.errors.name}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            variant="standard"
                                            className='mb-3 w-100'
                                            label="Mobile Number *"
                                            type="tel"
                                            inputProps={{
                                                maxLength: 10,
                                                inputMode: 'tel',
                                                pattern: '[0-9]*'
                                            }}
                                            id="mobile"
                                            name="mobile"
                                            value={formik.values.mobile}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("mobile", e.target.value.replace(/[^0-9]/g, ''));
                                            }}
                                            error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                                            helperText={formik.touched.mobile && formik.errors.mobile}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="email"
                                            name="email"
                                            label="Email ID *"
                                            type="text"
                                            value={formik.values.email}
                                            onChange={formik.handleChange}
                                            error={formik.touched.email && Boolean(formik.errors.email)}
                                            helperText={formik.touched.email && formik.errors.email}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="address"
                                            name="address"
                                            label="Address *"
                                            type="text"
                                            value={formik.values.address}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("address", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.address && Boolean(formik.errors.address)}
                                            helperText={formik.touched.address && formik.errors.address}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="city"
                                            name="city"
                                            label="City *"
                                            type="text"
                                            value={formik.values.city}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("city", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.city && Boolean(formik.errors.city)}
                                            helperText={formik.touched.city && formik.errors.city}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="state"
                                            name="state"
                                            label="State *"
                                            type="text"
                                            value={formik.values.state}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("state", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.state && Boolean(formik.errors.state)}
                                            helperText={formik.touched.state && formik.errors.state}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            variant="standard"
                                            className='mb-3 w-100'
                                            label="Postal Code *"
                                            type="tel"
                                            inputProps={{
                                                maxLength: 6,
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*'
                                            }}
                                            id="pincode"
                                            name="pincode"
                                            value={formik.values.pincode}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("pincode", e.target.value.replace(/[^0-9]/g, ''));
                                            }}
                                            error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                                            helperText={formik.touched.pincode && formik.errors.pincode}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <Autocomplete
                                            disablePortal
                                            id="country"
                                            className='mb-3'
                                            name="country"
                                            getOptionLabel={option => option.label}
                                            options={cddl}
                                            onChange={(e, value) => {
                                                //console.log('pas', value.value)
                                                formik.setFieldValue('country', value.value);
                                            }}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField
                                                variant="standard" {...params}
                                                error={formik.touched.country && Boolean(formik.errors.country)}
                                                helperText={formik.touched.country && formik.errors.country}
                                                label="Select Country *" />}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="firmName"
                                            name="firmName"
                                            label="Firm Name *"
                                            type="text"
                                            value={formik.values.firmName}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("firmName", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.firmName && Boolean(formik.errors.firmName)}
                                            helperText={formik.touched.firmName && formik.errors.firmName}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="geographical"
                                            multiline
                                            rows={2}
                                            name="geographical"
                                            label="Your Geographical Coverage *"
                                            type="text"
                                            value={formik.values.geographical}
                                            onChange={(e) => {
                                                formik.setFieldValue("geographical", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            // onChange={formik.handleChange}
                                            error={formik.touched.geographical && Boolean(formik.errors.geographical)}
                                            helperText={formik.touched.geographical && formik.errors.geographical}
                                        />
                                    </div>
                                    <div className='col-12'>
                                        <TextField
                                            className='mb-3 w-100'
                                            variant="standard"
                                            id="aboutbusiness"
                                            multiline
                                            rows={2}
                                            name="aboutbusiness"
                                            label="Tell us about your Business *"
                                            type="text"
                                            value={formik.values.aboutbusiness}
                                            // onChange={formik.handleChange}
                                            onChange={(e) => {
                                                formik.setFieldValue("aboutbusiness", e.target.value.replace(/[^a-zA-Z0-9,.\s]/gi, ''));
                                            }}
                                            error={formik.touched.aboutbusiness && Boolean(formik.errors.aboutbusiness)}
                                            helperText={formik.touched.aboutbusiness && formik.errors.aboutbusiness}
                                        />
                                    </div>
                                   
                                    <div className='col-12'>
                                        <div className='f12 mb-3'>
                                            <div className='d-flex align-items-center'>
                                                <div><FormGroup>
                                                    <FormControlLabel className='f14' control={<Checkbox className='f14' checked={agree} onChange={haveAgree} />} label="" />
                                                </FormGroup></div>
                                                <div className='fw-bold'>I accept the <Link to="/terms-of-use" target='_blank'>Terms & Privacy Policy</Link></div>
                                            </div>
                                        </div>
                                         <div className="col-12 mb-2">
                                        <ReCAPTCHA
                                            style={{ display: "inline-block" }}
                                            theme="light"
                                            ref={recaptchaRef}
                                            sitekey={TEST_SITE_KEY}
                                            onChange={onVerifyCaptcha}
                                            onExpired={() => {
                                                recaptchaRef.current.reset(); // here
                                                setCaptchavalue("");
                                            }}
                                        />
                                    </div>
                                        {!loading ? <Button color="error"
                                            disabled={!enabledbtncapt}
                                            variant="contained" className='w-100' type="submit">
                                            Submit
                                        </Button> : <LoadingButton className="w-100"
                                            loading
                                            //loadingPosition="end"
                                            variant="contained"
                                        >
                                            Submit...
                                        </LoadingButton>}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ clear: 'both', height: '40px' }}></div>
            <FotterMain />
        </>
    )
}

export default BecomeADealer